// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapperGRzVF","labelRow":"labelRowIYa0S","label":"labeldS4ZP","icon":"iconAw4VQ","dropdown":"dropdownOgtfx"};